import { createSelector } from "reselect";
import { REDUX_KEY } from "../../../utils/constants";

const reducerKey = REDUX_KEY.ANCILLARY;

export const getProjectionRequirements = createSelector(
  state => state[reducerKey].projectionRequirements,
  projectionRequirements => projectionRequirements
);
